import React from "react";
import classes from "./MotiveArea.module.css";
function MotiveArea() {
  return (
    <>
      <div className={classes.container}>
        <div className={classes.motive}>
          <p className={classes.speech}>
            " Our motive is to create a future where young people are informed,
            engaged, and equipped to make positive contributions to society. We
            believe that by fostering an interest in the environment, promoting
            sustainable practices, and providing education and training
            opportunities, we can help young people become informed and
            responsible citizens who are committed to making a positive impact
            on the world. Focusing on women's health issues, we aim to empower
            women and girls to make informed decisions about their own health
            and wellbeing, and to advocate for policies that promote gender
            equality and social justice... "
          </p>
        </div>
      </div>
    </>
  );
}

export default MotiveArea;
